<template>
    <b-container class="checkout_wrapper">

        <b-row>
            <b-col md="12">
                <h2>Order Summary: {{ordernumber}}</h2>
            </b-col>
        </b-row>

        <b-row>
            <b-col md="4">
                <b-card>
                    <table class="table table-striped mb-0 billing" v-if="project">
                        <tbody>
                            <tr class="first">
                                <th>First Name</th>
                                <td>{{billing.first_name}}</td>
                            </tr>
                            <tr>
                                <th>Last Name</th>
                                <td>{{billing.last_name}}</td>
                            </tr>
                            <tr>
                                <th>Street 1</th>
                                <td>{{billing.street_1}}</td>
                            </tr>
                            <tr>
                                <th>Street 2</th>
                                <td>{{billing.street_2}}</td>
                            </tr>
                            <tr>
                                <th>City</th>
                                <td>{{billing.city}}</td>
                            </tr>
                            <tr>
                                <th>State</th>
                                <td>{{billing.state}}</td>
                            </tr>
                            <tr>
                                <th>Zip Code</th>
                                <td>{{billing.postal_code}}</td>
                            </tr>
                            <tr>
                                <th>Country</th>
                                <td>{{billing.country}}</td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
            </b-col>
            <b-col md="8">
                <b-card>
                    <table v-if="project != null" class="table responsive">
                        <thead>
                            <tr>
                                <th style="width: 150px;">Name</th>
                                <th style="width: 125px;">Talent</th>
                                <th style="width: 80px;">Prompts</th>
                                <th style="width: 80px;">Words</th>
                                <th style="width: 105px;">Session Fee</th>
                                <th style="width: 105px;">Overage Fee</th>
                                <th style="width: 100px;" class="text-right">Subtotal</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><router-link :to="{name: 'review', params: {id: project.uuid}}">{{project.name}}</router-link></td>
                                <td>{{project.talent.persona}}</td>
                                <td class="text-center">{{project.prompts.length}}</td>
                                <td class="text-center">{{project.word_count}}</td>
                                <td class="text-center">${{project.record_fee}}</td>
                                <td class="text-center">${{extra_words_fee}}</td>
                                <td class="text-right">${{subtotal}}</td>
                            </tr>
                            <tr class="coupon-row" v-if="coupon.code">
                                <td colspan="6" class="text-right">
                                    Code: {{coupon.code}}
                                </td>
                                <td class="text-right">
                                    - ${{coupon.amount}}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="7" class="bottom-line">
                                    <table>
                                        <tbody>
                                            <tr>
                                                <td align="right">
                                                    
                                                </td>
                                                <td width="70" class="text-right"><strong>Total:</strong></td>
                                                <td width="100" class="total text-right">${{total_amount}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </b-card>
            </b-col>
        </b-row>        
    </b-container>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    export default {
        components: {Multiselect},
        data() {
            return {
                order_id: null,
                project: null,

                ordernumber: null,

                billing: {
                    first_name: '',
                    last_name: '',
                    street_1: '',
                    street_2: '',
                    city: '',
                    state: '',
                    postal_code: '',
                    country: 'US',
                    phone: ''
                },

                charge_amount: 0,

                coupon: {
                    coupon_code: null,
                    type: null,
                    amount: 0,
                    percent: 0
                },

                recordDays: [],

                week: [
                    'Sunday',
                    'Monday',
                    'Tuesday',
                    'Wednesday',
                    'Thursday',
                    'Friday',
                    'Saturday'
                ],

                schedule: {}
            };
        },
        methods: {

        },
        computed: {
            coupon_amount () {
                if (!this.coupon.coupon_code) {
                    return null
                }

                if (this.coupon.type == 'amount') {
                    return (this.subtotal - this.coupon.amount).toFixed(2)
                } else {
                    return (this.subtotal * this.coupon.percent).toFixed(2)
                }


            },
            extra_words_fee() {
               var extra_words_fee = 0;
               for(var i = 0; i < this.project.prompts.length; i++) {
                   extra_words_fee += parseFloat(this.project.prompts[i].extra_words_fee);
               }

               return extra_words_fee.toFixed(2);
           },
           subtotal() {
               var subtotal = 0;
               for(var i = 0; i < this.project.prompts.length; i++) {
                   subtotal += parseFloat(this.project.prompts[i].amount);
               }

               return (subtotal + parseFloat(this.project.record_fee)).toFixed(2);
           },
           total_amount() {
               if (this.coupon.code) {
                   return (this.subtotal - this.coupon.amount).toFixed(2)
               }
               return this.subtotal;
           },
           talentName () {
               return (this.project) ? this.project.talent.name : ''
           },
           weekdays () {
               return this.week.filter((day, i) => { return (i !== 0 && i !== 6) })
           }
        },
        created() {
            if( typeof( this.$route.params.id ) !== 'undefined' ) {
                 this.order_id = this.$route.params.id;
            }
            
            this.$store.dispatch('order/read', this.order_id)
                .then(order => {
                    this.project = order.projects[0]
                    this.ordernumber = order.id
                    this.charge_amount = order.total_amount
                    
                    if (order.coupon) {
                        this.coupon.type = order.coupon.type
                        this.coupon.amount = parseFloat(order.coupon.amount).toFixed(2)
                        if (order.coupon.type === 'percent') {      
                            this.coupon.percent = parseFloat(order.coupon.percent)
                            this.coupon.amount = (this.subtotal * parseFloat(order.coupon.percent)).toFixed(2)
                        }
                        this.coupon.code = order.coupon.coupon_code
                    }

                    this.recordDays = this.project.talent.record_day

                    if (this.recordDay && this.recordsDays.length > 0 && this.recordDays[0] != "") {
                        this.getNextRecordDay()
                    }

                    this.billing.first_name = order.user.first_name
                    this.billing.last_name = order.user.last_name

                    this.billing.street_1 = order.street_1
                    this.billing.street_2 = order.street_2
                    this.billing.city = order.city
                    this.billing.state = order.state
                    this.billing.country = order.country
                    this.billing.postal_code = order.postal_code
                    this.billing.phone = order.phone

                    if (this.project.status === 'draft') {
                        // redirect to checkout
                    }
                })

        }
    };
</script>


// WEBPACK FOOTER //
// prompts/views/orders/Order.vue